import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { Skeleton } from '@atlassian/jira-common-components-skeleton/src/styled.tsx';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledFieldSkeleton = styled(Skeleton)({
	height: '40px',
	width: '350px',
	marginBottom: token('space.075'),
});
StyledFieldSkeleton.displayName = 'FieldSkeleton';
